import { render, staticRenderFns } from "./orderDetailsList.vue?vue&type=template&id=366b5cb7&"
import script from "./orderDetailsList.vue?vue&type=script&lang=js&"
export * from "./orderDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailsList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports